import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import CustomNavigationTab from 'components/shared/CustomNavigationTab/CustomNavigationTab';

import SimilarCompanies from './Companies';
import Contacts from './Contacts';
import Header from './Header';
import muiStyles from './muiStyles';
import News from './News';
import Overview from './Overview';
import PlatformInsights from './PlatformInsights';
import Relationship from './Relationship';
import { useBusinessDetails } from './useBusinessDetails';
import { usePermissions } from 'customHook/usePermissions';

const BusinessSelected = () => {
  const { id } = useParams();
  const { data, loading } = useBusinessDetails(id ?? '');
  const { hasAction, hasFullAccess } = usePermissions();

  const [value, setValue] = useState(0);
  const canViewRelationshipTab =
    hasAction('businesses', 'BusinessDetailsRelationship', 'view') || hasFullAccess('businesses');
  const canViewCompanyIntelTab =
    hasAction('businesses', 'companyintel', 'view') || hasFullAccess('businesses');
  const canViewContactsTab =
    hasAction('businesses', 'contacts', 'view') || hasFullAccess('businesses');
  const canViewPlatformInsightsTab =
    hasAction('businesses', 'platforminsights', 'view') || hasFullAccess('businesses');
  const canViewNewsTab = hasAction('businesses', 'news', 'view') || hasFullAccess('businesses');
  const canViewSimilarCompaniesTab =
    hasAction('businesses', 'similarcompanies', 'view') || hasFullAccess('businesses');

  const tabsData = [
    ...(canViewRelationshipTab
      ? [
          {
            label: 'Relationship',
            Component: <Relationship />,
          },
        ]
      : []),
    ...(canViewCompanyIntelTab
      ? [
          {
            label: 'Company Intel',
            Component: <Overview />,
          },
        ]
      : []),

    ...(canViewContactsTab
      ? [
          {
            label: 'Contacts',
            Component: <Contacts />,
          },
        ]
      : []),
    ...(canViewPlatformInsightsTab
      ? [
          {
            label: 'Platform Insights',
            Component: <PlatformInsights />,
          },
        ]
      : []),
    ...(canViewNewsTab
      ? [
          {
            label: 'News',
            Component: <News />,
          },
        ]
      : []),
    ...(canViewSimilarCompaniesTab
      ? [
          {
            label: 'Similar Companies',
            Component: <SimilarCompanies />,
          },
        ]
      : []),
  ];

  const tabs = tabsData.map((tab, index) => {
    const { label, Component } = tab;

    return {
      label,
      id: index + 1,
      isHidden: value !== index,
      Component,
    };
  });

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentBusinessTab', newValue.toString());
    setValue(newValue);
  };

  if (loading || !data) return <CustomLoader open />;

  return (
    <>
      <Header data={data} />
      <Box sx={muiStyles.content}>
        <CustomNavigationTab tabs={tabs} handleChange={handleChange} value={value} />
      </Box>
    </>
  );
};

export default BusinessSelected;
